import expImg from "../assets/images/experience.svg";
export const experienceData = {
  title: "Experience",
  image: expImg,
  data: [
    {
      id: 1,
      company: "Ognale Software Solutions",
      jobtitle: "Wordpress and HTML Developer",
      startYear: "2021",
      endYear: "2021",
      city: "Thoothukudi",
    },
    {
      id: 2,
      company: "Thidiff Technologies",
      jobtitle: "Junior Software Engineer",
      startYear: "2021",
      endYear: "2022",
      city: "Bangalore",
    },
    {
      id: 3,
      company: "Starberry Ltd",
      jobtitle: "Software Engineer",
      startYear: "2022",
      endYear: "Present",
      city: "Coimbatore",
    },
  ],
};
